import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.75146 3.05176e-05L6.75147 13.2728", stroke: "currentColor", strokeWidth: 1.0004 }), /* @__PURE__ */ React.createElement("path", { d: "M0.115234 6.63641H13.388", stroke: "currentColor", strokeWidth: 1.0004 }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
